import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import AddSupportingEvidenceForm from '../../../../accs/form/add-supporting-evidence'

const formValue = 'add_supporting_document_form'

const available = (record) =>
  hasAvailableAction(record, 'add_supporting_document')

const calculateSubmitValues = (values) => {
  const gov_id = values.gov_id
  const evidence = values.evidence ? values.evidence : []
  
  const newEvidence = evidence.map((item) => {
    item['id'] = gov_id
    return item
  })
  const submitValues = { ...values, evidence: newEvidence }
  return submitValues
}

const defaultValues = (gov_id) => {
  return {
    gov_id: gov_id,
    evidence: []
  }
}

const actionForm = ({ regHolderId, record }) => ({ handleSuccess }) => {
  const gov_id = record.gov_id
  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/accs/${gov_id}/supporting-documents`
      }
      name={formValue}
      label='Add Evidence'
      calculateSubmitValues={calculateSubmitValues}
      handleSuccess={() =>
        handleSuccess({ [formValue]: 'Evidence added.' }, formValue)
      }
      formOptions={{ defaultValues: defaultValues(gov_id) }}
      formComponent={(props) => (
        <AddSupportingEvidenceForm {...props} required={false} limit={1} />
      )}
    />
  )
}

export const addCertificateEvidence = ({
  regHolderId,
  record,
  refresh_accs_gov_enrolments
}) => {
  return available(record)
    ? {
      label: 'Add Evidence',
      value: 'add_supporting_document_form',
      actionForm: actionForm({ record, regHolderId }),
      onCompletePreserveAction: true,
      onComplete: refresh_accs_gov_enrolments
    }
    : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/add-certificate-evidence/index.js